/**
 * Which faces the signup row shows, and which of them is speaking.
 * First-impressions design §3. Alternating rather than the first five in sort
 * order: the seeded order puts five children first, and a parent signing up is
 * as much the audience as their child.
 */
export const CAST_MAX = 5;
export const SPEAK_EVERY_MS = 4000;
export const SPEAK_FOR_MS = 1200;

export function castFor<T extends { audience: string }>(all: readonly T[], max = CAST_MAX): T[] {
  const kids = all.filter((x) => x.audience === 'kid');
  const adults = all.filter((x) => x.audience !== 'kid');
  const [first, second] = all[0]?.audience === 'kid' ? [kids, adults] : [adults, kids];
  const out: T[] = [];
  for (let i = 0; out.length < max && (i < first.length || i < second.length); i++) {
    if (i < first.length) out.push(first[i]);
    if (out.length < max && i < second.length) out.push(second[i]);
  }
  return out;
}

/** One face at a time, so the row is alive without everything moving at once. */
export function speakingIndex(phase: number, count: number): number | null {
  if (count === 0 || phase <= 0) return null;
  if (phase % SPEAK_EVERY_MS >= SPEAK_FOR_MS) return null;
  return Math.floor(phase / SPEAK_EVERY_MS) % count;
}
